import { c as _c } from "react/compiler-runtime";
import { classNames, FlexCenter, IconCallout, TextBody } from "@opensea/ui-kit";
import { Info } from "@opensea/ui-kit/icons";
import { useTranslations } from "use-intl";
export function CrossEcosystemSwapNotification(t0) {
  const $ = _c(10);
  const {
    className
  } = t0;
  const t = useTranslations("wallet.CrossEcosystemSwapNotification");
  let t1;
  if ($[0] !== className) {
    t1 = classNames("gap-2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconCallout icon={Info} size={16} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("message");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <TextBody color="text-secondary" size="sm">{t3}</TextBody>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t4) {
    t5 = <FlexCenter className={t1}>{t2}{t4}</FlexCenter>;
    $[7] = t1;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}